import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { queryClient } from "../../../../../../../utils/queryClient";
import { useMutation, useQuery } from "react-query";
//primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
//components
import Select from "../../../../../../../components/input/Select";
import Toggle from "../../../../../../../components/button/Toggle";
import NumberInput from "../../../../../../../components/input/NumberInput";
//services
import { getOwner } from "../../../../../../../services/GlobalRoles/getOwner";
import { getLandOwners } from "../../../../../../../services/Contracts/getLandOwners";
import { postLandOwners } from "../../../../../../../services/Contracts/postLandOwners";
//pages
import { FiltersOwners } from "./FiltersOwners";
import { useAppContext } from "../../../../../../../context/AppContext";
import { Skeleton } from "primereact/skeleton";

const Owners = ({ setActiveIndex, id }) => {
  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const columns = [
    { field: "name", header: "Nome" },
    { field: "percentage", header: "% de Participação" },
    {
      field: "owner",
      header: "Proprietário Titular",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.owner) {
          case 1:
            labelClass = "badge bg-success";
            labelText = "Titular";
            break;
          case 0:
            labelClass = "";
            labelText = "";
            break;
          default:
        }

        return (
          <span
            className={labelClass}
            style={{
              fontSize: "12px",
              marginLeft: "15px",
              marginRight: "-40px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
  ];

  const [Visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [defaultValues, setDefaultValues] = useState([{}]);
  const [totalPercentage, setTotalPercentage] = useState(0);

  const formEdit = useForm();
  const errorsEdit = formEdit.formState.errors;
  const handleSubmit = formEdit.handleSubmit;

  const { data: owners, isLoading: loadingOwners } = useQuery({
    queryKey: ["owners"],
    queryFn: () => getOwner(),
    enabled: !!permissions?.includes("59")
  });

  const { data: landOwners, isLoading: loadingLandOwners } = useQuery({
    queryKey: [`landOwners${id}`],
    queryFn: () => getLandOwners(id),
    enabled: !!permissions?.includes("59")
  });

  useEffect(() => {
    if (landOwners) {
      if (landOwners.owners) {
        const newData = landOwners.owners.map((itemOwner) => {
          const ownerLabel = owners.find(
            (item) => item.id === itemOwner.client_id
          )?.name;
          return {
            ...itemOwner,
            owner: itemOwner.owner ? 1 : 0,
            name: ownerLabel,
          };
        });
        setTableData(newData);
      } else {
        const newData = landOwners.map((owner) => {
          return {
            client_id: owner.client_id,
            name: owner.client.name,
            percentage: owner.percentage,
            owner: owner.owner,
          };
        });
        setTableData(newData);
      }
    }
  }, [landOwners]);

  useEffect(() => {
    const total = testPercentage();
    setTotalPercentage(total);
  }, [defaultValues]);

  const click = (data) => {
    const newDefaultValues = data.map((item) => {
      formEdit.setValue(`owner[${item.client_id}]`, item.client_id);
      formEdit.setValue(`percentage[${item.client_id}]`, item.percentage);
      formEdit.setValue(`holder[${item.client_id}]`, item.owner);

      return {
        owner: item.client_id,
        percentage: item.percentage,
        holder: item.owner === 1,
      };
    });
    setDefaultValues(newDefaultValues);
    setVisible(true);
  };

  const { mutateAsync: postLandOwnersFn } = useMutation({
    mutationFn: postLandOwners,
    onSuccess(_, variables) {
      // console.log("variables: ", variables);
      queryClient.setQueryData([`landOwners${id}`], (data) => {
        // console.log(data)
        return variables;
      });
    },
    onError(error) {
      // console.log(error);
    },
  });

  const editOwner = async (data) => {
    // console.log("Edit data: ", data);
    const notification = toast.loading("Por favor aguarde...");
    const formattedData = data.owner
      .map((owner) => {
        // console.log("Owner: ", owner);
        if (owner) {
          if (data.percentage[owner] === 0 || data.percentage[owner] === null) {
            formEdit.setValue(`owner[${owner}]`, 0);
            formEdit.setValue(`percentage[${owner}]`, 0);
            formEdit.setValue(`holder[${owner}]`, 0);
          } else {
            return {
              client_id: owner,
              percentage: data.percentage[owner] ? data.percentage[owner] : 0,
              owner: data.holder[owner] ? data.holder[owner] : 0,
            };
          }
        }
      })
      .filter((item) => item !== undefined);

    // console.log("formattedData: ", formattedData);

    data.sale_id = id;
    data.owners = formattedData;

    delete data.owner;
    delete data.percentage;
    delete data.holder;

    try {
      await postLandOwnersFn(data);
      // console.log(response);
      setDefaultValues(formattedData);
      toast.update(notification, {
        render: "Informação Salva com Sucesso",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setVisible(false);
    } catch (err) {
      // console.log(err);
      toast.update(notification, {
        render: "Falha ao executar a ação!",
        autoClose: 5000,
        type: "error",
        theme: "colored",
        isLoading: false,
      });
    }
  };

  const onChangeHolder = (cliId) => {
    const valueToggle = formEdit.getValues(`holder[${cliId}]`);
    if (valueToggle) {
      defaultValues.forEach((owner) => {
        if (owner.owner !== cliId) {
          formEdit.setValue(`holder[${owner.owner}]`, false);
        }
      });
    }
  };

  const testPercentage = () => {
    let total = 0;
    defaultValues.map((c) => {
      if (c.percentage) {
        total += c.percentage;
      }
      return total;
    });
    return total;
  };

  const handleInputChange = (cliId, index) => {
    const updatedValues = [...defaultValues];
    const inputValue = formEdit.getValues(`percentage[${cliId}]`);
    updatedValues[index] = {
      ...updatedValues[index],
      percentage: inputValue,
    };
    setDefaultValues(updatedValues);
  };

  const getFormErrorMessage = (name) => {
    return errorsEdit[name] ? (
      <small className="p-error">{errorsEdit[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  return (
    <>
      <div className="row">
        <div className="card-border me-2 my-2">
          <div className="title-container">
            <p>
              {" "}
              <i className="fa-solid fa-users me-2"></i>Proprietários
            </p>
          </div>
          <div className="row my-2 p-4">
            <h4 className="text-success">
              <i className="fa-solid fa-circle-plus mx-2"></i>Cadastro de
              Proprietários
            </h4>
            <hr></hr>
            <FiltersOwners id={id} />
            <h4 className="text-success mt-4">
              <i className="fa-solid fa-users mx-2"></i>Proprietários do{" "}
              {nomenclature[1].value}
            </h4>
            <hr></hr>
            {loadingLandOwners ? (
              <Skeleton width="100%" height="150px" />
            ) : (
              <DataTable
                rows={5}
                stripedRows
                showGridlines
                sortMode="multiple"
                selectionMode="single"
                value={tableData}
                // loading={loadingLandOwners}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
              >
                {columns.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    body={col.body}
                  />
                ))}
                {permissions && permissions.includes("77") && ( //Cadastrar / Editar Proprietarios  
                  <Column
                    header="Editar"
                    body={(rowData) => (
                      <div className="text-center">
                        <button
                          className="btn btn-info btn-btn-sm"
                          onClick={(e) => click(tableData)}
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                        </button>
                      </div>
                    )}
                  />
                )}
              </DataTable>
            )}
          </div>
        </div>
      </div>
      <Dialog
        header="Editar Proprietários"
        className=""
        visible={Visible}
        position={"center"}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
        draggable={false}
        resizable={false}
      >
        <form onSubmit={handleSubmit(editOwner)} autoComplete="off">
          {tableData.map((owner, index) => (
            <div className="row" key={index}>
              <div className="col-md-4">
                <Select
                  name={`owner[${owner.client_id}]`}
                  label={loadingOwners ? "Carregando..." : "Proprietário"}
                  disabled={loadingOwners}
                  errors={errorsEdit}
                  control={formEdit.control}
                  options={
                    owners &&
                    owners.map((item) => {
                      return {
                        value: item.id,
                        label: item.name,
                      };
                    })
                  }
                />
              </div>
              <div className="col-md-3">
                <NumberInput
                  name={`percentage[${owner.client_id}]`}
                  suffix="%"
                  defaultValue={owner.percentage}
                  placeholder="0%"
                  max={100}
                  onChange={() => handleInputChange(owner.client_id, index)}
                  errors={errorsEdit}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  control={formEdit.control}
                  label="% Participação"
                />
              </div>
              <div className="col-md-3 mt-2 form-group pt-3 ms-2">
                <Toggle
                  name={`holder[${owner.client_id}]`}
                  control={formEdit.control}
                  onLabel="Titular"
                  offLabel="Titular"
                  onChange={() => onChangeHolder(owner.client_id)}
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
            </div>
          ))}
          <div className="d-flex justify-content-end mt-4">
            <Button
              label="Cancelar"
              type="button"
              icon="pi pi-times"
              onClick={() => setVisible(false)}
              className="p-button-text"
            />
            <Button
              label="Editar"
              icon="pi pi-check"
              type="submit"
              disabled={totalPercentage !== 100}
            />
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default Owners;
